var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5018 4.44254C19.8096 4.71963 19.8346 5.19385 19.5575 5.50173L11.8199 14.0991C10.8454 15.1819 9.19549 15.3168 8.05793 14.4068L4.53151 11.5857C4.20806 11.3269 4.15562 10.8549 4.41438 10.5315C4.67313 10.208 5.1451 10.1556 5.46855 10.4144L8.99497 13.2355C9.51204 13.6492 10.262 13.5878 10.705 13.0956L18.4426 4.49828C18.7197 4.1904 19.1939 4.16544 19.5018 4.44254Z",
    fill: "#5AF0BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61424 16.357C5.96943 16.1439 6.43012 16.2591 6.64323 16.6142C6.93128 17.0943 8.09726 18.2501 10.0001 18.2501C11.903 18.2501 13.0689 17.0943 13.357 16.6142C13.5701 16.2591 14.0308 16.1439 14.386 16.357C14.7412 16.5701 14.8563 17.0308 14.6432 17.386C14.1313 18.2392 12.5155 19.7501 10.0001 19.7501C7.48469 19.7501 5.86894 18.2392 5.35699 17.386C5.14388 17.0308 5.25906 16.5701 5.61424 16.357Z",
    fill: "#5AF0BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess);
export default __webpack_public_path__ + "static/media/message-success.75f2bd056fa699c4e4ed1bdfbee757cb.svg";
export { ForwardRef as ReactComponent };